import styled from 'styled-components';
export const NewsletterModalContent = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  text-align: center;

  .eyebrowHeader {
    margin-bottom: var(--space-xs);
  }

  h2 {
    margin: 0 0 var(--space-m) 0;

    color: var(--grey7);

    font-size: clamp(2rem, 4vw, 3rem);
    line-height: 1.05;
    font-weight: 900;

    letter-spacing: -0.04em;
  }

  .modalIntro {
    max-width: 560px;

    margin: 0 0 var(--space-xl) 0;

    color: var(--grey4);

    font-size: 1rem;
    line-height: 1.75;
    font-weight: 500;
  }
`;

export const NewsletterModalFinePrint = styled.span`
  max-width: 520px;

  display: block;

  margin-block: var(--space-s);

  color: var(--grey3);

  font-size: 0.85rem;
  line-height: 1.6;
  font-weight: 500;
  font-style: italic;
`;

export const NewsletterModalStatus = styled.p`
  margin: 0;

  text-align: center;

  color: ${({ $success }) =>
    $success ? 'var(--successGreen)' : 'var(--errorRed)'};

  font-size: 0.95rem;
  line-height: 1.5;
  font-weight: 700;
`;
